interface Props {
  width?: string;
  height?: string;
}

const Pill = ({ width = '24', height = '24' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      style={{ display: 'block' }}
    >
      <path
        d="M10.53 15.47a.75.75 0 0 1 0 1.06l-2 2a2.164 2.164 0 0 1-3.055.006.748.748 0 0 1 .23-1.234.751.751 0 0 1 .824.167c.26.26.68.26.94 0l2-2a.75.75 0 0 1 1.06 0zM13.3 3.523a5.071 5.071 0 1 1 7.172 7.172l-9.778 9.778a5.071 5.071 0 1 1-7.172-7.172L13.3 3.524zm6.111 1.061a3.57 3.57 0 0 0-5.05 0l-4.359 4.36 5.05 5.05 4.36-4.36a3.57 3.57 0 0 0 0-5.05zm-5.418 10.47-5.05-5.05-4.359 4.358a3.571 3.571 0 1 0 5.05 5.05l4.36-4.358z"
        fill="#4C3422"
      />
    </svg>
  );
};

export default Pill;
